<template>
    <v-layout row wrap>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading">
            <v-card class="mb-3">
                <v-card-title class="primary white--text headline">
                    {{ 'Builder'|translate }}
                    <v-spacer></v-spacer>
                    <span style="width:150px;">
                        <v-switch color="success" v-model="showConnectors" style="height:30px;"
                                  :label="'Connectors'|translate"></v-switch>
                    </span>
                    <v-menu offset-y v-if="$can('update', 'Points')">
                        <template v-slot:activator="{ on }">
                            <v-btn
                                color="primary elevation-4"
                                dark
                                v-on="on"
                            >
                                <v-icon small class="mr-2">fa-plus</v-icon>
                                {{'Add'|translate }}
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-tile  @click="equipDialog=true">
                                <v-list-tile-title>{{ 'Equipment'|translate }}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile  @click="mcpDialog=true">
                                <v-list-tile-title>{{ 'Calculated Points'|translate }}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile  @click="mwpDialog=true">
                                <v-list-tile-title>{{ 'Writable Points'|translate }}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile  @click="autoRefDiag=true">
                                <v-list-tile-title>{{ 'Equipment Relationships'|translate }}</v-list-tile-title>
                            </v-list-tile>

                        </v-list>
                    </v-menu>
                    <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn
                                color="primary elevation-4"
                                dark
                                v-on="on"
                            >
                                <v-icon small class="mr-2">fa-file</v-icon>
                                {{'Point list'|translate }}
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-tile @click="uploadDialog=true" v-if="$can('update', 'Points')">
                                <v-list-tile-title>{{'Upload'|translate}}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile  @click="exportPoints">
                                <v-list-tile-title>{{'Download'|translate}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                    <v-menu offset-y v-if="$can('update', 'Points')">
                        <template v-slot:activator="{ on }">
                            <v-btn
                                color="primary elevation-4"
                                dark
                                v-on="on"
                            >
                                <v-icon small class="mr-2">fa-upload</v-icon>
                                {{'Data'|translate }}
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-tile @click="multiUploadDialog=true" >
                                <v-list-tile-title>{{'Upload Data'|translate}}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile  @click="recalcDiag=true">
                                <v-list-tile-title>{{'Recalculate Points'|translate}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                    <maintenance-upload-dialog
                        v-model="uploadDialog"
                        v-if="uploadDialog"
                        endpoint="/point-list-upload/"
                        diff-options
                        v-on:doreload="reloadTree(); uploadDialog=false"
                        :title="'Point List upload'|translate"
                        :upload-title="'Upload Point List CSV'|translate"
                    >
                    </maintenance-upload-dialog>
                    <maintenance-upload-dialog
                        v-model="multiUploadDialog"
                        v-if="multiUploadDialog"
                        endpoint="/multiple-series-upload/"
                        cleanup
                        title="Data Upload"
                        v-on:doreload="multiUploadDialog=false"
                        upload-title="Upload CSV/Excel Data"
                    >
                    </maintenance-upload-dialog>
                    <equipment-record-dialog v-model="equipDialog" :item="{}" v-on:reloadequipments="reloadTree();equipDialog=false"></equipment-record-dialog>
                    <v-dialog v-model="mcpDialog" :max-width="800">
                        <v-card v-if="mcpDialog">
                            <v-card-title class="primary white--text title">
                                {{'Add Multiple Calculated Points'|translate}}
                            </v-card-title>
                            <v-card-text>
                                <v-autocomplete clearable v-model="mcpTypeFilter" :label="'Equipment Type filter'|translate" :items="equipTypeFilterOptions"></v-autocomplete>
                                <v-autocomplete clearable v-model="mcpFloorFilter" :label="'Equipment Floor filter'|translate" :items="equipFloorFilterOptions"></v-autocomplete>
                                <v-text-field v-model="mcpName" type="text" :label="'Sensor Name'|translate"></v-text-field>
                                <v-text-field v-model="mcpForumla" clearable type="text" :label="'Sensor Formula'|translate" :hint="'ID replacement supported. Equipment that lack sensors are skipped.'|translate"></v-text-field>
                              <v-text-field v-model="mcpUnit" type="text" :label="'Unit'|translate" clearable></v-text-field>
                                <v-switch color="success"
                                          v-model="mcpEditExisting"
                                          :label="'Edit Existing Points'|translate"
                                ></v-switch>
                                <div v-if="(mcpTypeFilter||mcpFloorFilter)&&mcpName&&mcpName!==''">
                                    <v-alert v-if="matchingMCPTargets.length>0"
                                             :value="true"
                                             style="padding: 6px;"
                                             type="success"
                                    >
                                        {{'Matching Equipment : '|translate}}
                                        <v-chip v-for="item in matchingMCPTargets">{{item.name}}
                                            <v-icon small v-if="item.isAdd" class="ml-2">fa-plus</v-icon>
                                            <v-icon small v-if="item.isEdit" class="ml-2">fa-edit</v-icon>
                                        </v-chip>
                                    </v-alert>
                                </div>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn outline class="mr-2" @click="mcpDialog=false">{{'Cancel'|translate}}</v-btn>
                                <v-btn class="primary mr-2 elevation-4" @click="runMCP" :disabled="!$can('update', 'Points')||(!mcpTypeFilter&&!mcpFloorFilter)||!mcpName">{{'Create for all matching equipment'|translate}}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="mwpDialog" :max-width="800">
                        <v-card v-if="mwpDialog">
                            <v-card-title class="primary white--text title">
                                {{'Add Multiple Writable Points'|translate}}
                            </v-card-title>
                            <v-card-text>
                                <v-autocomplete clearable v-model="mwpTypeFilter" :label="'Equipment Type filter'|translate" :items="equipTypeFilterOptions"></v-autocomplete>
                                <v-autocomplete clearable v-model="mwpFloorFilter" :label="'Equipment Floor filter'|translate" :items="equipFloorFilterOptions"></v-autocomplete>
                                <v-text-field v-model="mwpName" type="text" :label="'Sensor Name'|translate"></v-text-field>
                                <v-switch color="success"
                                          v-model="mwpEditExisting"
                                          :label="'Edit Existing Points'|translate"
                                ></v-switch>
                                <div v-if="(mwpTypeFilter||mwpFloorFilter)&&mwpName&&mwpName!==''">
                                    <v-alert v-if="matchingMWPTargets.length>0"
                                             :value="true"
                                             style="padding: 6px;"
                                             type="success"
                                    >
                                        {{'Matching Equipment : '|translate}}
                                        <v-chip v-for="item in matchingMWPTargets">{{item.name}}
                                            <v-icon small v-if="item.isAdd" class="ml-2">fa-plus</v-icon>
                                            <v-icon small v-if="item.isEdit" class="ml-2">fa-edit</v-icon>
                                        </v-chip>
                                    </v-alert>
                                </div>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn outline class="mr-2" @click="mwpDialog=false">{{'Cancel'|translate}}</v-btn>
                                <v-btn class="primary mr-2 elevation-4" @click="runMWP" :disabled="!$can('update', 'Points')||(!mwpTypeFilter&&!mwpFloorFilter)||!mwpName">{{'Create for all matching equipment'|translate}}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="misWorkflowDialog" fullscreen persistent>
                        <v-card v-if="misWorkflowDialog">
                            <v-card-title class="primary white--text title">
                                {{'Mapping Integrity Missing Points'|translate}}
                            </v-card-title>
                            <v-card-text>
                                <v-layout row>
                            <span style="width:300px;"><v-text-field class="ml-2" clearable v-model="misSearch"
                                                                     type="text"
                                                                     :placeholder="'Keyword filter'|translate"></v-text-field></span>
                                    <span style="width:300px;">
                                                    <v-select
                                                        color="white"
                                                        :items="misWorkflowSeverityOptions"
                                                        class="mx-4"
                                                        multiple
                                                        label="Show severity"
                                                        v-model="misWorkflowSeverity">
                                                    </v-select>
                                                </span>
                                    <span style="width:150px;">
                                                <v-switch color="success" :label="'Pending Only'|translate"
                                                          v-model="misPendingOnly"></v-switch>
                                                </span>
                                    <v-spacer></v-spacer>
                                    <span class="ml-3" style="width:200px;">
                                                    <value-box
                                                        :value="completionPercentage"
                                                        unit="%"
                                                        icon=""
                                                        use-int
                                                        :title="'Mapping Completion'|translate">
                        </value-box>
                                                </span>
                                </v-layout>
                                <v-data-table
                                    :headers="integrityHeaders"
                                    :items="refinedMisIssues"
                                    :search="misSearch2"
                                    :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                                    :items-per-page="25"
                                >
                                    <template v-slot:items="props">
                                        <td>{{ props.item.equipment_name }}</td>
                                        <td>{{ props.item.sensor_name }}</td>
                                        <td><v-chip :color="getColor(props.item.severity)" style="color:#404040 !important;">
                                            {{ props.item.severity }}
                                        </v-chip></td>
                                        <td>{{ props.item.equipment_type }}</td>
                                        <td>{{ props.item.floor }}</td>
                                        <td class="pa-0">
                                            <v-textarea class="pa-0 ma-0 no-field-underline"
                                                        v-model="props.item.notes"
                                                        :clearable="true"
                                                        :rows="1"
                                                        :auto-grow="true"
                                            ></v-textarea>
                                        </td>
                                        <td>
                                            <span v-if="props.item.status==='done'">{{'Ignored'|translate}}</span>
                                            <span v-if="props.item.status!=='done'">{{ props.item.status }}</span>
                                        </td>
                                        <td>
                                            <v-tooltip bottom v-if="props.item.status==='pending'">
                                                <template v-slot:activator="{ on }" >
                                                    <v-icon small v-on="on" class="cursor-as-pointer"  @click="props.item.status='done'">fa-check</v-icon>
                                                </template>
                                                <span>{{'Mark as ignored'|translate}}</span>
                                            </v-tooltip>
                                            <v-tooltip bottom v-if="props.item.status==='pending'">
                                                <template v-slot:activator="{ on }" >
                                                    <v-icon small v-on="on" class="cursor-as-pointer ml-2"  @click="markAllAsDone(props.item)">fa-check-double</v-icon>
                                                </template>
                                                <span>{{'Mark all as ignored'|translate}}</span>
                                            </v-tooltip>
                                            <v-tooltip bottom v-if="props.item.status==='done'">
                                                <template v-slot:activator="{ on }" >
                                                    <v-icon small v-on="on" class="cursor-as-pointer"  @click="props.item.status='pending'">fa-bell</v-icon>
                                                </template>
                                                <span>{{'Mark as pending'|translate}}</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-icon small v-on="on" class="ml-2 cursor-as-pointer"
                                                            @click="misRenameExisting(props.item)">fa-edit
                                                    </v-icon>
                                                </template>
                                                <span>{{ 'Rename existing point'|translate }}</span>
                                            </v-tooltip>
                                            <v-tooltip bottom v-if="props.item.canCalc">
                                                <template v-slot:activator="{ on }">
                                                    <v-icon small v-on="on" class="ml-2 cursor-as-pointer"
                                                            @click="addToMisItem(props.item)">fa-calculator
                                                    </v-icon>
                                                </template>
                                                <span>{{ 'Create as calculated point'|translate }}</span>
                                            </v-tooltip>
                                            <v-tooltip bottom v-if="props.item.canBeWritable&&writableConnector">
                                                <template v-slot:activator="{ on }">
                                                    <v-icon small v-on="on" class="ml-2 cursor-as-pointer"
                                                            @click="addWritableToMisItem(props.item)">fa-plus
                                                    </v-icon>
                                                </template>
                                                <span>{{ 'Create as writable point'|translate }}</span>
                                            </v-tooltip>

                                        </td>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn class="primary elevation-4 ml-2" @click="addToAllMisItems" :disabled="!canCreateAllCalc"><v-icon small class="mr-2">fa-calculator</v-icon>{{'Add all missing calculated points'|translate}}</v-btn>
                                <v-btn class="primary elevation-4 ml-2" @click="addWritableToAllMisItems" :disabled="!canCreateAllWritable" v-if="writableConnector"><v-icon small class="mr-2">fa-plus</v-icon>{{'Add all missing writable points'|translate}}</v-btn>
                                <v-btn class="primary elevation-4 ml-2" @click="exportAsPointListToMap" v-if="refinedMisIssues&&refinedMisIssues.length>0"><v-icon small class="mr-2">fa-download</v-icon>{{'Export as point list'|translate}}</v-btn>
                                <v-spacer></v-spacer>
                                <v-btn outline class="mr-2" @click="closeMisDialog">{{'Done'|translate}}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="misRenameDialog" fullscreen persistent>
                        <v-card v-if="misRenameDialog">
                            <v-card-title class="primary white--text title">
                               {{misRenameItem.equipment_name}} : {{' rename existing point to '|translate}} {{misRenameItem.sensor_name}}
                            </v-card-title>
                            <v-card-text>
                                <v-layout row>
                                    <span style="width:300px;"><v-text-field class="mr-4" clearable v-model="misRenameSearch" type="text"
                                                                             :placeholder="'Keyword filter'|translate"></v-text-field></span>
                                    <span style="width:150px;">
                        <v-switch color="success" v-model="misRenameSearchBeyondEquipment" style="height:30px;"
                                  :label="'Show all points'|translate"></v-switch>
                    </span>
                                    <v-spacer></v-spacer>
                                </v-layout>
                                <v-data-table
                                              :headers="misRenameHeaders"
                                              :items="misRenameCandidatePoints"
                                              :search="misRenameSearch2"
                                              class="elevation-1"
                                              :rows-per-page-items="[10,25,50,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                                              :items-per-page="10"
                                >
                                    <template v-slot:items="props">
                                        <td>{{ props.item.sensor_id }}</td>
                                        <td class="text-xs-left">{{ props.item.sensor_name }}</td>
                                        <td class="text-xs-left">
                                            {{ props.item.sensor_name_abbr }}
                                        </td>
                                        <td class="text-xs-left">{{ props.item.unit }}</td>
                                        <td class="text-xs-left">{{ props.item.haystack_id }}</td>
                                        <td class="text-xs-left">{{ props.item.equipment_name }}</td>
                                        <td class="text-xs-left">{{ props.item.meta }}</td>
                                        <td class="justify-center" style="min-width:150px;">

                                            <v-tooltip bottom v-if="$can('update', 'Points')">
                                                <template v-slot:activator="{ on }" >
                                                    <v-icon
                                                        small
                                                        class="mr-2"
                                                        v-on="on"
                                                        @click="misRenameSelectedPoint=props.item"
                                                    >
                                                        fa-check
                                                    </v-icon>
                                                </template>
                                                <span>{{'Preview'|translate}}</span>
                                            </v-tooltip>
                                        </td>
                                    </template>
                                    <template v-slot:no-data>
                                        <v-btn color="primary" @click="initialize">{{ 'Reset'|translate }}</v-btn>
                                    </template>
                                </v-data-table>
                                <data3-chart v-if="misRenameSelectedPoint" class="mt-4"
                                             :layout-overrides="configForMisRename['layout-overrides']"
                                             :on-only="false"
                                             :x-axis="configForMisRename['x-axis']"
                                             :y-axis="configForMisRename['y-axis']"
                                             :color-axis="configForMisRename['color-axis']"
                                             :color-axis-scale="configForMisRename['color-axis-scale']"
                                             :color-axis-title="configForMisRename['color-axis-title']"
                                             disable-responsive
                                             show-units
                                             :data-payload="configForMisRename['data-payload']"
                                             :series-overrides="configForMisRename['series-overrides']"
                                             :date-range="range"></data3-chart>
                                <v-alert v-if="misRenameSelectedPoint"
                                         :value="true"
                                         color="info"
                                         style="padding: 6px;"
                                >
                                    <strong>{{ misRenameSelectedPoint.equipment_name }} - {{ misRenameSelectedPoint.sensor_name }}</strong> {{ "will be renamed to" |translate}} <strong>{{misRenameItem.equipment_name}} - {{misRenameItem.sensor_name}}</strong>
                                </v-alert>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn outline class="mr-2" @click="misRenameDialog=false">{{'Cancel'|translate}}</v-btn>
                                <v-btn class="primary mr-2 elevation-4" @click="runMisRename" :disabled="!$can('update', 'Points')||!misRenameSelectedPoint">{{'Confirm rename '|translate}}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="recalcDiag" :max-width="600">
                        <v-card v-if="recalcDiag">
                            <v-card-title class="primary white--text title">
                                {{'Recalculate Multiple Calculated Points'|translate}}
                            </v-card-title>
                            <v-card-text>
                                <v-autocomplete v-model="recalcName" :label="'Sensor Name'|translate" :items="calcPointNameFilterOptions"></v-autocomplete>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn outline class="mr-2" @click="recalcDiag=false">{{'Cancel'|translate}}</v-btn>
                                <v-btn class="primary mr-2 elevation-4" @click="runMultiRecalc" :disabled="!$can('update', 'Points')||!recalcName">{{'Recalculate for all matching points'|translate}}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="autoRefDiag" :max-width="600">
                        <v-card v-if="autoRefDiag">
                            <v-card-title class="primary white--text title">
                                {{'Auto-create Equipment Relationship'|translate}}
                            </v-card-title>
                            <v-card-text>
                                <p>{{'Relationships will be created based on "autoRefConfig". Any existing relationships will not be altered. This cannot be reversed.'|translate}}</p>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn outline class="mr-2" @click="autoRefDiag=false">{{'Cancel'|translate}}</v-btn>
                                <v-btn class="primary mr-2 elevation-4" @click="autoBuildRelationships" :disabled="!$can('update', 'Points')">{{'Run'|translate}}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                </v-card-title>
            </v-card>
        </v-flex>
        <v-flex :class="showConnectors ? 'xs6' : '12'" v-if="!loading">
            <v-layout>
                <v-flex md4>
                    <v-card>
                        <v-card-title class="primary">
                            <v-layout row>
                                <span style="width:200px;">
                                    <v-text-field clearable v-model="search" type="text" class="ma-0 pa-0" hide-details
                                                  :placeholder="'Keyword filter'|translate"></v-text-field>
                                </span>
                                <v-spacer></v-spacer>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }" >
                                        <v-icon small v-on="on" :color="debugMode ? 'success' : null" class="mr-2 mt-2 cursor-as-pointer" v-if="canSwitchToDebug" @click="debugMode=!debugMode">fa-bug</v-icon>
                                    </template>
                                    <span>{{'Toggle Debug Mode'|translate}}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }" >
                                        <v-icon small v-on="on" class="mr-2 mt-2 cursor-as-pointer" v-if="canSwitchToDebug" @click="runMIS">fa-list</v-icon>
                                    </template>
                                    <span>{{'Run Integrity Scan'|translate}}</span>
                                </v-tooltip>

                            </v-layout>

                        </v-card-title>
                        <v-card-text :style="'overflow-y: auto; overflow-x: auto; max-height: ' +blockHeight+'px;'">
                            <v-treeview :search="search2"
                                        :items="cleanedTree"
                                        :filter="customSearch"
                                        :open.sync="open"
                                        item-key="id"
                            >
                                <template v-slot:label="{ item }">
                                    <span class="cursor-as-pointer pa-1" v-bind:class="{ 'v-treeview-node--active': selectedID&&selectedID===item.id }" @click="handleClick(item)">{{item.name}}
                                        <span v-if="debugMode&&item.itemType==='equipment'" v-html="getItemDebugStatus(item)"></span>
                                        <span v-if="item.itemType==='equipment'&&item.itemData&&item.itemData.equipment_type==='trash'">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-icon small v-on="on" class="ml-2" color="error">fa-trash</v-icon>
                                                </template>
                                                <span>{{ 'Equipment deletion in progress'|translate }}</span>
                                            </v-tooltip>
                                        </span>
                                    </span>
                                </template>
                            </v-treeview>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex md8>
                    <v-card v-if="selectedItem" class="ml-3">
                        <v-card-title class="headline primary white--text" v-if="selectedType==='equipment'">
                            <v-icon small class="mr-2">fa-server</v-icon> {{selectedItem.equipment_name}}
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }" >
                                    <v-icon small v-on="on" class="mr-3 cursor-as-pointer" v-if="$can('update', 'Points')" @click="dialog2=true">fa-plus</v-icon>
                                </template>
                                <span>{{'Add Point'|translate}}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }" >
                                    <v-icon small v-on="on" class="mr-3 cursor-as-pointer" v-if="$can('update', 'Equipment')" @click="dialog=true">fa-edit</v-icon>
                                </template>
                                <span>{{'Edit Equipment'|translate}}</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }" >
                                    <v-icon small v-on="on" class="mr-2 cursor-as-pointer" v-if="$can('update', 'Equipment')" @click="deleteEquipment(selectedItem)">fa-trash</v-icon>
                                </template>
                                <span>{{'Delete Equipment'|translate}}</span>
                            </v-tooltip>
                            <equipment-record-dialog v-if="$can('update', 'Equipment')" v-model="dialog" :item="selectedItem" v-on:reloadequipments="reloadTree"></equipment-record-dialog>
                            <point-record-dialog v-if="$can('update', 'Points')" v-model="dialog2" :item="{'facility_name': facilityName,'equipment_name':selectedItem.equipment_name}" v-on:reloadpoints="reloadTree"></point-record-dialog>
                        </v-card-title>
                        <v-card-title class="headline primary white--text" v-if="selectedType==='sensor'">
                            <v-icon small class="mr-2">fa-wifi</v-icon> {{selectedItem.equipment_name}} > {{selectedItem.sensor_name}}
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }" >
                                    <v-icon small v-on="on" class="mr-3 cursor-as-pointer" v-if="$can('update', 'Points')" @click="dialog2=true">fa-upload</v-icon>
                                </template>
                                <span>{{'Upload Data'|translate}}</span>
                            </v-tooltip>
                            <v-tooltip bottom v-if="$can('update', 'SoftwareSwitches')&&selectedItem.meta&& selectedItem.meta.tags && selectedItem.meta.tags.includes('writable')">
                                <template v-slot:activator="{ on }" >
                                    <v-icon small v-on="on" class="mr-3 cursor-as-pointer" @click="writeValueDialog=true">fa-pencil-alt</v-icon>
                                </template>
                                <span>{{'Write Value'|translate}}</span>
                            </v-tooltip>
                            <v-tooltip bottom v-if="$can('update', 'Points')&&selectedItem.calculations_statement&&selectedItem.calculations_statement!==''">
                                <template v-slot:activator="{ on }" >
                                    <v-icon small v-on="on" class="mr-3 cursor-as-pointer" @click="runPointRecalc">fa-calculator</v-icon>
                                </template>
                                <span>{{'Recalculate'|translate}}</span>
                            </v-tooltip>
                            <v-tooltip bottom v-if="$can('update', 'Points')&&(!selectedItem.calculations_statement||selectedItem.calculations_statement==='')&&selectedItem.connector_id&&selectedItem.haystack_id">
                                <template v-slot:activator="{ on }" >
                                    <v-icon small v-on="on" class="mr-3 cursor-as-pointer" @click="importJobDialog=true">fa-download</v-icon>
                                </template>
                                <span>{{'Re-import history'|translate}}</span>
                            </v-tooltip>
                            <v-tooltip bottom v-if="$can('update', 'Points')">
                                <template v-slot:activator="{ on }" >
                                    <v-icon small v-on="on" class="mr-3 cursor-as-pointer"  @click="dialog=true">fa-edit</v-icon>
                                </template>
                                <span>{{'Edit Point'|translate}}</span>
                            </v-tooltip>
                            <v-tooltip bottom v-if="$can('update', 'Points')">
                                <template v-slot:activator="{ on }" >
                                    <v-icon small v-on="on" class="mr-2 cursor-as-pointer"  @click="deleteSensor(selectedItem)">fa-trash</v-icon>
                                </template>
                                <span>{{'Delete Point'|translate}}</span>
                            </v-tooltip>
                            <point-record-dialog v-if="$can('update', 'Points')" v-model="dialog" :item="selectedItem" v-on:reloadpoints="reloadTree"></point-record-dialog>
                            <maintenance-upload-dialog
                                v-model="dialog2"
                                v-if="dialog2&&selectedItem"
                                endpoint="/series-upload/"
                                cleanup
                                :sensor-id="selectedItem.sensor_id"
                                v-on:doreload="dialog2=false;"
                                :title="'Upload data for '+ facilityName+' - '+selectedItem.equipment_name+' - '+selectedItem.sensor_name"
                                :upload-title="'Upload CSV data for '+facilityName+' - '+selectedItem.equipment_name+' - '+selectedItem.sensor_name"
                            >
                            </maintenance-upload-dialog>
                            <v-dialog v-model="importJobDialog" :max-width="600">
                                <v-card v-if="importJobDialog&&selectedItem">
                                    <v-card-title class="primary white--text title">
                                        {{'Re-import history for '|translate}} {{selectedItem.equipment_name}} - {{selectedItem.sensor_name}}
                                    </v-card-title>
                                    <v-card-text>
                                        <v-layout row wrap>
                                            <v-flex xs12>
                                                <v-text-field type="date"  :label="'Start Date'|translate" v-model="importJobStartDate" ></v-text-field>
                                                <v-text-field type="date"  :label="'End Date'|translate" v-model="importJobEndDate" ></v-text-field>
                                            </v-flex>
                                        </v-layout>

                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn outline class="mr-2" @click="importJobDialog=false">{{'Cancel'|translate}}</v-btn>
                                        <v-btn class="primary mr-2 elevation-4" @click="runPointRedump(); importJobDialog=false" :disabled="!importJobStartDate||!importJobEndDate">{{'Create Job'|translate}}</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                            <v-dialog v-model="writeValueDialog" :max-width="1000">
                                <v-card v-if="writeValueDialog&&selectedItem">
                                    <v-card-title class="primary white--text title">
                                        {{selectedItem.equipment_name}} - {{selectedItem.sensor_name}}
                                    </v-card-title>
                                    <v-card-text>
                                        <v-layout row wrap>
                                            <v-flex xs12 md6 v-if="selectedItem.meta.writable_priority_array">
                                                <ol>
                                                    <li v-for="(item,priority) in selectedItem.meta.writable_priority_array">
                                                        <span v-if="item">{{item.value}}  {{formatElderDate(item.deadline)}}
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-icon small v-on="on" class="ml-3"
                                                                            @click="clearPriority(selectedItem.sensor_id,priority+1)">fa-trash</v-icon>
                                                                </template>
                                                                <span>{{ 'Clear & Save'|translate }}</span>
                                                            </v-tooltip>
                                                        </span>
                                                        <span v-if="!item">null</span>
                                                    </li>
                                                </ol>
                                            </v-flex>
                                            <v-flex xs12 :class="selectedItem.meta.writable_priority_array ? 'md6': ''">
                                                <v-text-field :label="'Sensor ID'|translate" v-model="selectedItem.sensor_id" disabled></v-text-field>
                                                <v-text-field :label="'Upstream ID'|translate" v-model="selectedItem.haystack_id" disabled></v-text-field>
                                                <v-text-field :label="'Value'|translate" v-model.number="selectedItem.value" clearable :rules="selectedItem.meta.writable_value_range ? [value => value < selectedItem.meta.writable_value_range[0] || 'Min value is '+selectedItem.meta.writable_value_range[0], value => value > selectedItem.meta.writable_value_range[1] || 'Max value is '+selectedItem.meta.writable_value_range[1]] : []"></v-text-field>
                                                <v-text-field :label="'Priority'|translate" v-model.number="selectedItem.priority"></v-text-field>
                                                <v-text-field :label="'Duration (seconds)'|translate" v-model.number="selectedItem.duration" clearable></v-text-field>
                                            </v-flex>
                                        </v-layout>

                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn outline class="mr-2" @click="writeValueDialog=false">{{'Cancel'|translate}}</v-btn>
                                        <v-btn class="primary mr-2 elevation-4" @click="updateControl(selectedItem.sensor_id,selectedItem.value,selectedItem.priority,selectedItem.duration)" :disabled="!$can('update', 'SoftwareSwitches')">{{'Save'|translate}}</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-card-title>
                        <v-card-text v-if="selectedType==='equipment'">
                            <v-layout row wrap>
                                <v-flex md6>
                                    <p v-if="selectedItem.equipment_id"><strong>{{'Equipment ID'|translate}} : </strong>{{selectedItem.equipment_id}}</p>
                                    <p v-if="selectedItem.equipment_name"><strong>{{'Equipment Name'|translate}} : </strong>{{selectedItem.equipment_name}}</p>
                                    <p v-if="selectedItem.equipment_type"><strong>{{'Equipment Type'|translate}} : </strong>{{selectedItem.equipment_type}}</p>
                                    <p v-if="selectedItem.equipment_tags&&selectedItem.equipment_tags.length>0"><strong>{{'Equipment Tags'|translate}} : </strong>
                                        <v-chip v-for="tag in selectedItem.equipment_tags">{{tag}}</v-chip>
                                    </p>
                                </v-flex>
                                <v-flex md6>
                                    <p v-if="selectedItem.floor"><strong>{{'Floor'|translate}} : </strong>{{selectedItem.floor}}</p>
                                    <p v-if="selectedItem.notes"><strong>{{'Notes'|translate}} : </strong>{{selectedItem.notes}}</p>
                                </v-flex>
                                <v-flex xs12>
                                    <p v-for="calcPoint in calculatedPointRecommendations">
                                        {{'Add calculated point'|translate}} <strong>{{calcPoint.name}}</strong> <v-tooltip bottom>
                                        <template v-slot:activator="{ on }" >
                                            <v-icon small v-on="on" class="ml-3 cursor-as-pointer" v-if="$can('update', 'Points')" @click="addPointToCurrent(calcPoint.name,calcPoint.formula)">fa-plus-square</v-icon>
                                        </template>
                                        <span>{{'Add as calculated point'|translate}}</span>
                                    </v-tooltip>
                                    </p>
                                </v-flex>
                                <v-flex xs12 v-if="debugMode">
                                    <v-alert v-for="integIssue in equipmentIntegrityIssues"
                                        :value="true"
                                        :color="integIssue.status"
                                             style="padding: 6px;"
                                    >
                                        {{ integIssue.description }}
                                        <v-chip v-for="missingThing in integIssue.sensors">{{missingThing}}</v-chip>
                                    </v-alert>
                                    <v-alert v-for="note in equipmentIntegrityNotes"
                                        :value="true"
                                        color="info"
                                             style="padding: 6px;"
                                    >
                                        Note on <strong>{{ note.sensor_name }}</strong> : {{ note.notes }}
                                    </v-alert>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-card-text v-if="selectedType==='sensor'">
                            <v-layout>
                                <v-flex md6>
                                    <p v-if="selectedItem.sensor_id"><strong>{{'Sensor ID'|translate}} : </strong>{{selectedItem.sensor_id}}</p>
                                    <p v-if="selectedItem.sensor_name"><strong>{{'Sensor Name'|translate}} : </strong>{{selectedItem.sensor_name}}</p>
                                    <p v-if="selectedItem.sensor_name_abbr"><strong>{{'Sensor Name Abbr'|translate}} : </strong>{{selectedItem.sensor_name_abbr}}</p>
                                    <p v-if="selectedItem.equipment_name"><strong>{{'Equipment Name'|translate}} : </strong>{{selectedItem.equipment_name}}</p>
                                    <p v-if="selectedItem.unit"><strong>{{'Unit'|translate}} : </strong>{{selectedItem.unit}}</p>
                                </v-flex>
                                <v-flex md6>
                                    <p><strong>{{'Faulty'|translate}} : </strong> {{selectedItem.faulty ? 'yes' : 'no'|translate}}</p>
                                    <p v-if="selectedItem.connector_id"><strong>{{'Connector'|translate}} : </strong>{{getConnectorInfo(selectedItem.connector_id)}}</p>
                                    <p v-if="selectedItem.haystack_id"><strong>{{'Upstream ID'|translate}} : </strong>{{selectedItem.haystack_id}}</p>
                                    <p v-if="selectedItem.sensor_desc"><strong>{{'Sensor Description'|translate}} : </strong>{{selectedItem.sensor_desc}}</p>
                                    <p v-if="selectedItem.weight"><strong>{{'Weight'|translate}} : </strong>{{selectedItem.weight}}</p>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-card-title class="primary white--text subheading">{{'Data'|translate}}
                            <span class="ml-3">
                                <date-range-selector style="width: 220px;" v-model="range"></date-range-selector>
                            </span>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-card-text v-if="selectedType==='equipment'">
                            <data3-chart v-for="plot in plotConfig"
                                         :layout-overrides="plot['layout-overrides']"
                                         :on-only="false"
                                         :x-axis="plot['x-axis']"
                                         :y-axis="plot['y-axis']"
                                         :color-axis="plot['color-axis']"
                                         :color-axis-scale="plot['color-axis-scale']"
                                         :color-axis-title="plot['color-axis-title']"
                                         disable-responsive
                                         show-units
                                         :data-payload="plot['data-payload']"
                                         :series-overrides="plot['series-overrides']"
                                         :date-range="range"></data3-chart>
                        </v-card-text>
                        <v-card-text v-if="selectedType==='sensor'">
                            <data3-chart v-if="plotConfig"
                                         :layout-overrides="plotConfig['layout-overrides']"
                                         :on-only="false"
                                         :x-axis="plotConfig['x-axis']"
                                         :y-axis="plotConfig['y-axis']"
                                         :color-axis="plotConfig['color-axis']"
                                         :color-axis-scale="plotConfig['color-axis-scale']"
                                         :color-axis-title="plotConfig['color-axis-title']"
                                         disable-responsive
                                         show-units
                                         :data-payload="plotConfig['data-payload']"
                                         :series-overrides="plotConfig['series-overrides']"
                                         :date-range="range"></data3-chart>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex xs6 v-if="showConnectors">
            <connectors class="ml-3" side-mode :mappedext="mappedIds" :equipment-name="selectedItem&&selectedItem.equipment_name ? selectedItem.equipment_name : null" @addpoint="addFromConnector"></connectors>
            <point-record-dialog v-if="$can('update', 'Points')" v-model="dialog3" :item="itemFromConnector" v-on:reloadpoints="reloadTree"></point-record-dialog>
        </v-flex>
    </v-layout>
</template>

<script>
import {
    getEquipment,
    deleteEquipment,
    getPoint,
    deletePoint,
    sortFloors,
    getConnector,
    putOptimizationControl,
    putPoint, putJob, getEquipmentRelationship, putEquipmentRelationship, putResult, getResult, putEquipment
} from '../helper'
import EquipmentRecordDialog from '../components/equipment/EquipmentRecordDialog'
import PointRecordDialog from '../components/points/PointRecordDialog'
import Data3Chart from "../components/Data3Chart";
import DateRangeSelector from "../components/DateRangeSelector";
import moment from 'moment'
import MaintenanceUploadDialog from "../components/maintenance/MaintenanceUploadDialog";
import Connectors from "./Connectors";
import calculatedDef from '../config/pointMapping/calculated'
import autoRef from '../config/pointMapping/autoref'
import integrity from '../config/pointMapping/integrity'
import {mapGetters} from "vuex";
import _ from "lodash";
import {exportCSV} from "../tocsv";
import ValueBox from "../components/ValueBox.vue";

export default {
    name: 'Builder',
  components: { EquipmentRecordDialog, PointRecordDialog,Data3Chart,DateRangeSelector,MaintenanceUploadDialog,Connectors,ValueBox},
    data() {
        return {
      loading: true,
      open:[],
      search:null,
      search2:null,
            misSearch: null,
            misSearch2: null,
            misRenameSearch: null,
            misRenameSearch2: null,
            misRenameSearchBeyondEquipment:false,
      misWorkflowDialog:false,
      misWorkflowSeverity:['critical','important'],
      misWorkflowSeverityOptions:['critical','important','optional'],
      misPendingOnly:true,
      misIssues:[],
      completionPercentage:null,
      integrityHeaders: [
          {text: this.$options.filters.translate('Equipment Name'), value: 'equipment_name'},
          {text: this.$options.filters.translate('Sensor Name'), value: 'sensor_name'},
          {text: this.$options.filters.translate('Severity'), value: 'severity'},
          {text: this.$options.filters.translate('Equipment Type'), value: 'equipment_type'},
          {text: this.$options.filters.translate('Floor'), value: 'floor'},
          {text: this.$options.filters.translate('Notes'), value: 'notes',sortable: false},
          {text: this.$options.filters.translate('Status'), value: 'status'},
          {text: this.$options.filters.translate('Actions'), value: 'name', sortable: false},
      ],
      debugMode:false,
      itemFromConnector:null,
      showConnectors:false,
      dialog:false,
      writeValueDialog:false,
            errorColors: {
                'critical': 'error',
                'important': 'warning',
                'optional': 'info',
                'OK': 'green'
            },
      dialog2:false,
      dialog3:false,
      importJobEndDate: null,
      importJobStartDate: null,
      importJobDialog:false,
      uploadDialog:false,
      mappedIds:[],
      multiUploadDialog:false,
      knownExistingIssues: [],
      connectors:[],
      equipDialog:false,
      mcpDialog:false,
      mwpDialog:false,
      tree:null,
      timeout:null,
      selectedItem:null,
      selectedID:null,
      selectedType:null,
      selectedItemChildren:null,
      recalcDiag:false,
      autoRefDiag:false,
      recalcName:null,
      allEquipments:[],
      allPoints:[],
      allRelationships:[],
      mcpTypeFilter:null,
      mwpTypeFilter:null,
      mcpFloorFilter:null,
      mwpFloorFilter:null,
      mcpName:null,
      mwpName:null,
      mcpForumla:null,
      mcpUnit:null,
      mcpEditExisting:false,
      mwpEditExisting:false,
      massCalcCreateFormula:null,
      range: {start: moment().subtract(30, "days").format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD')},
      misRenameItem:null,
      misRenameSelectedPoint:null,
      misRenameDialog:false,
      misRenameHeaders:[
            {
                text: this.$options.filters.translate('Sensor ID'),
                align: 'left',
                value: 'sensor_id'
            },
            {text: this.$options.filters.translate('Sensor Name'), value: 'sensor_name'},
            {text: this.$options.filters.translate('Sensor Name Abbr'), value: 'sensor_name_abbr'},
            {text: this.$options.filters.translate('Unit'), value: 'unit'},
            {text: this.$options.filters.translate('Upstream ID'), value: 'haystack_id'},
            {text: this.$options.filters.translate('Equipment Name'), value: 'equipment_name'},
            {text: this.$options.filters.translate('Meta'), value: 'meta', sortable: false},
            {text: this.$options.filters.translate('Actions'), sortable: false},
        ],
    }},

  mounted() {
    this.reloadTree()
  },
    watch: {
        search() {
            this.debounce(this.syncSearches, 500);
        },
        misSearch() {
            this.debounce(this.syncMisSearches, 500);
        },
        misRenameSearch() {
            this.debounce(this.syncMisRenameSearches, 500);
        }

    },
    async beforeMount() {
        let maxDate = this.$store.state.pointsListStore.pointsList.data_max_date;
        let rangeStart = _.get(this.$route.query, 'rangeStart', null)
        let rangeEnd = _.get(this.$route.query, 'rangeEnd', null)
        if (!!rangeStart) {
            this.range = {start: rangeStart, end: rangeEnd}
        } else if (maxDate) {
            this.range = {
                start: moment(maxDate).subtract(30, "days").format('YYYY-MM-DD'),
                end: moment(maxDate).format('YYYY-MM-DD')
            }
        }
        let df = await getConnector({
            facility_name: this.$store.state.pointsListStore.pointsList.facility_name
        })
        this.connectors = df['result']
    },
    computed: {
        ...mapGetters([
            'mappingCalculatedConfig','mappingIntegrityConfig','mappingRefConfig',
        ]),
        misRenameCandidatePoints(){
            if (this.misRenameItem&&this.allPoints&&this.allPoints.length>0){
                if (this.misRenameSearchBeyondEquipment){
                    return this.allPoints.filter(x => x.equipment_name !== this.misRenameItem.equipment_name || x.sensor_name !== this.misRenameItem.sensor_name)
                } else {
                    return this.allPoints.filter(x => x.equipment_name === this.misRenameItem.equipment_name && x.sensor_name !== this.misRenameItem.sensor_name)
                }
            }
            return []
        },
        canCreateAllCalc(){
          if (this.misIssues&&this.misIssues.length>0){
              return this.misIssues.filter(x=>x.canCalc&&x.status==="pending"&&this.misWorkflowSeverity.includes(x.severity)).length>0
          }
          return false
        },
        canCreateAllWritable(){
            if (this.misIssues&&this.misIssues.length>0){
                return this.misIssues.filter(x=>x.canBeWritable&&x.status==="pending"&&this.misWorkflowSeverity.includes(x.severity)).length>0
            }
            return false
        },
        matchingMCPTargets(){
            if (!this.mcpTypeFilter&&!this.mcpFloorFilter){
                return []
            }
            let equips = JSON.parse(JSON.stringify(this.allEquipments))
            if (this.mcpTypeFilter) {
                equips = equips.filter(x => x.equipment_type === this.mcpTypeFilter)
            }
            if (this.mcpFloorFilter) {
                equips = equips.filter(x => x.floor === this.mcpFloorFilter)
            }
            let foundMatches=equips.map(x=>{return{name:x.equipment_name}})
            if (this.mcpName&&this.mcpName!==""){
                for (let item of foundMatches){
                    if (this.allPoints.filter(x => x.equipment_name === item.name && x.sensor_name === this.mcpName).length === 0){
                        item.isAdd=true
                    } else if(this.mcpEditExisting){
                        item.isEdit=true
                    }
                }
            }
            return foundMatches
        },
        matchingMWPTargets(){
            if (!this.mwpTypeFilter&&!this.mwpFloorFilter){
                return []
            }
            let equips = JSON.parse(JSON.stringify(this.allEquipments))
            if (this.mwpTypeFilter) {
                equips = equips.filter(x => x.equipment_type === this.mwpTypeFilter)
            }
            if (this.mwpFloorFilter) {
                equips = equips.filter(x => x.floor === this.mwpFloorFilter)
            }
            let foundMatches=equips.map(x=>{return{name:x.equipment_name}})
            if (this.mwpName&&this.mwpName!==""){
                for (let item of foundMatches){
                    if (this.allPoints.filter(x => x.equipment_name === item.name && x.sensor_name === this.mwpName).length === 0){
                        item.isAdd=true
                    } else if(this.mwpEditExisting){
                        item.isEdit=true
                    }
                }
            }
            return foundMatches
        },
        writableConnector(){
            let found=this.connectors.filter(x=>x.type==="writable")
            return found.length>0 ? found[0] : null
        },
        calculatedPointRecommendations(){
            if (this.selectedItem&&this.selectedType==='equipment'){
                let availableOnesDef=this.mappingCalculatedConfig ? this.mappingCalculatedConfig : calculatedDef
                let availableOnes=availableOnesDef.filter(x=>x.equipment_type===this.selectedItem.equipment_type)
                let recs = []
                let equipPoints=this.allPoints.filter(x=>x.equipment_name===this.selectedItem.equipment_name).map(x=>x.sensor_name)
                for (let calcPoint of availableOnes) {
                    if (!equipPoints.includes(calcPoint.name) && calcPoint.requirements.filter(x => !x.includes(" - ")).every(x => equipPoints.includes(x)) && calcPoint.requirements.filter(x => x.includes(" - ")).every(x => this.allPoints.filter(point => point.equipment_name===x.split(" - ")[0]&&point.sensor_name===x.split(" - ")[1]).length>0)) {
                        recs.push(calcPoint)
                    }
                }
                return recs
            }
            return []
        },
        refinedMisIssues(){
            let issues=this.misIssues
            issues=issues.filter(x=>this.misWorkflowSeverity.includes(x.severity))
            if (this.misPendingOnly){
                issues=issues.filter(x=>x.status==="pending")
            } else {
                issues=issues.filter(x=>x.status!=="auto-created")
            }
            return issues
        },
        equipmentIntegrityIssues() {
            if (this.debugMode&&this.selectedItem && this.selectedType === 'equipment') {
                let integrityConfig = this.mappingIntegrityConfig ? this.mappingIntegrityConfig : integrity
                let currentTags = this.selectedItem.equipment_tags&&this.selectedItem.equipment_tags.length>0 ? this.selectedItem.equipment_tags : []
                let issuesForType = integrityConfig.filter(x => x.equipmentGroup&&x.equipmentGroup.split(",").includes(this.selectedItem.equipment_type)&&(!x.equipmentTags||x.equipmentTags.length===0||x.equipmentTags.every(tag=>currentTags.includes(tag))))
                let issues = []
                let equipPoints=this.allPoints.filter(x=>x.equipment_name===this.selectedItem.equipment_name).map(x=>x.sensor_name)
                let ignoredForThisOne=[]
                if (this.knownExistingIssues&&this.knownExistingIssues.length>0){
                    ignoredForThisOne=this.knownExistingIssues.filter(x=>x.status==="done").filter(x=>x.equipment_name===this.selectedItem.equipment_name).map(x=>x.sensor_name)
                }
                let integrityIssue = {
                    missingCriticalSensors: issuesForType.filter(x => x.importance === "critical").map(x => x.carnotname).filter(x => !equipPoints.includes(x)&&!ignoredForThisOne.includes(x)),
                    missingImportantSensors: issuesForType.filter(x => x.importance === "important").map(x => x.carnotname).filter(x => !equipPoints.includes(x)&&!ignoredForThisOne.includes(x)),
                    missingOptionalSensors: issuesForType.filter(x => x.importance === "optional").map(x => x.carnotname).filter(x => !equipPoints.includes(x)&&!ignoredForThisOne.includes(x)),
                }
                if (integrityIssue.missingCriticalSensors.length > 0) {
                    issues.push({
                        description: this.$options.filters.translate("Missing critical sensors: "),
                        sensors:integrityIssue.missingCriticalSensors,
                        status: "error"
                    })

                }
                if (integrityIssue.missingImportantSensors.length > 0) {
                    issues.push({
                        description: this.$options.filters.translate("Missing important sensors: "),
                        sensors:integrityIssue.missingImportantSensors,
                        status: "warning"
                    })
                }
                // if (integrityIssue.missingOptionalSensors.length > 0) {
                //     issues.push({
                //         description: this.$options.filters.translate("Missing optional sensors: "),
                //         sensors:integrityIssue.missingOptionalSensors,
                //         status: "info"
                //     })
                // }
                return issues
            }
            return []
        },
        equipmentIntegrityNotes() {
            if (this.debugMode&&this.selectedItem && this.selectedType === 'equipment'&&this.knownExistingIssues&&this.knownExistingIssues.length>0) {
                return this.knownExistingIssues.filter(x=>x.equipment_name===this.selectedItem.equipment_name&&x.notes&&x.notes!=="")
            }
            return []
        },
        canSwitchToDebug() {
            if (this.$store.state.userStore.user) {
                if (process.env.VUE_APP_EXTERNAL_AUTH&&process.env.VUE_APP_EXTERNAL_AUTH==="msal"&&this.$store.state.userStore.user.content.role==="admin"){
                    return true
                } else if (process.env.VUE_APP_SUPERUSER&&process.env.VUE_APP_SUPERUSER!==""){
                    return this.$store.state.userStore.user.content.user_name.toLowerCase().includes(process.env.VUE_APP_SUPERUSER)
                } else {
                    return this.$store.state.userStore.user.content.user_name === "jecdavid" || this.$store.state.userStore.user.content.user_name.toLowerCase().includes("carnot")
                }
            }
            return false;
        },
        equipTypeFilterOptions(){
            return JSON.parse(JSON.stringify([...new Set(this.allEquipments.filter(x=>x.equipment_type).map(x=>x.equipment_type))])).sort()
        },
        equipFloorFilterOptions(){
            return JSON.parse(JSON.stringify([...new Set(this.allEquipments.filter(x=>x.floor).map(x=>x.floor))])).sort()
        },
        calcPointNameFilterOptions(){
            return JSON.parse(JSON.stringify([...new Set(this.allPoints.filter(x=>x.sensor_name&&x.calculations_statement&&x.calculations_statement!=="").map(x=>x.sensor_name))])).sort()
        },
        facilityName(){
            return this.$store.state.pointsListStore.pointsList.facility_name;
        },
        blockHeight(){
          return window.innerHeight-100
        },
        cleanedTree() {
            return JSON.parse(JSON.stringify(this.tree)) //this is just here to scrap observers and not kill tree performance
        },
        configForMisRename(){
            if (this.misRenameSelectedPoint&&this.misRenameItem){
                let config={
                    'layout-overrides': {
                        title:this.misRenameSelectedPoint.equipment_name + " - " + this.misRenameSelectedPoint.sensor_name+ " : " + this.$options.filters.translate("data preview"),
                        colorway: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf'],
                        xaxis: {
                            title: this.$options.filters.translate("Time")
                        },
                        yaxis: {
                            title: this.misRenameSelectedPoint.unit
                        },
                        zaxis: {
                            title: null
                        },
                        showlegend:true,
                        height:300,
                        hovermode:"x",
                        margin:{
                            l: 50,
                            r: 50,
                            t: 50,
                            pad: 1
                        },
                        legend: {
                            orientation: 'h',
                            y: -0.3
                        },
                    },
                    "x-axis":"timestamp",
                    "y-axis":null,
                    "color-axis":null,
                    "color-axis-scale":null,
                    "color-axis-title":null,
                    'data-payload': [{
                        'filters': {
                            equipment_name: this.misRenameSelectedPoint.equipment_name,
                            sensor_name: this.misRenameSelectedPoint.sensor_name,
                            facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                        },
                        seriesOverrides:{
                            type:'scatter',
                            opacity:1,
                            xbins: {
                                size: 1
                            },
                            ybins: {
                                size: 1
                            }
                        },
                    }],
                }
                if (this.misRenameItem.lowerLimit||this.misRenameItem.lowerLimit===0){
                    config["data-payload"].push({
                        'filters': {
                            equipment_name: this.misRenameSelectedPoint.equipment_name,
                            sensor_name: this.misRenameSelectedPoint.sensor_name,
                            facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                        },
                        pipeline:[{
                            type: "calculate",
                            formula: this.misRenameItem.lowerLimit.toString(),
                            name: "lower limit",
                            "remove_others": true
                        }],
                        seriesOverrides:{
                            type:'scatter',
                            mode:'lines',
                            line: {
                                dash: 'dash'
                            },
                            opacity:1,
                            xbins: {
                                size: 1
                            },
                            ybins: {
                                size: 1
                            }
                        },
                    })
                }
                if (this.misRenameItem.upperLimit||this.misRenameItem.upperLimit===0){
                    config["data-payload"].push({
                        'filters': {
                            equipment_name: this.misRenameSelectedPoint.equipment_name,
                            sensor_name: this.misRenameSelectedPoint.sensor_name,
                            facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                        },
                        pipeline:[{
                            type: "calculate",
                            formula: this.misRenameItem.upperLimit.toString(),
                            name: "upper limit",
                            "remove_others": true
                        }],
                        seriesOverrides:{
                            type:'scatter',
                            mode:'lines',
                            line: {
                                dash: 'dash'
                            },
                            opacity:1,
                            xbins: {
                                size: 1
                            },
                            ybins: {
                                size: 1
                            }
                        },
                    })
                }
                return config
            }
            return null
        },
        plotConfig(){
            if (this.selectedType&&this.selectedType==='sensor'){
                return  {
                    'layout-overrides': {
                        title:"",
                        colorway: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf'],
                        xaxis: {
                            title: this.$options.filters.translate("Time")
                        },
                        yaxis: {
                            title: this.selectedItem.unit
                        },
                        zaxis: {
                            title: null
                        },
                        showlegend:true,
                        height:300,
                        hovermode:"x",
                        margin:{
                            l: 50,
                            r: 50,
                            t: 50,
                            pad: 1
                        },
                        legend: {
                            orientation: 'h',
                            y: -0.3
                        },
                    },
                    "x-axis":"timestamp",
                    "y-axis":null,
                    "color-axis":null,
                    "color-axis-scale":null,
                    "color-axis-title":null,
                    'data-payload': [{
                        'filters': {
                            equipment_name: this.selectedItem.equipment_name,
                            sensor_name: this.selectedItem.sensor_name,
                            facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                        },
                        seriesOverrides:{
                            type:'scatter',
                            opacity:1,
                            xbins: {
                                size: 1
                            },
                            ybins: {
                                size: 1
                            }
                        },
                    }],
                }
            } else if (this.selectedType&&this.selectedType==='equipment'&&this.selectedItemChildren){
                let newVarList={};
                for (let sensor of this.selectedItemChildren){
                    let unit = sensor.itemData.unit ? sensor.itemData.unit : ""
                    if (!newVarList[unit]) {
                        newVarList[unit] = [];
                    }
                    newVarList[unit].push({
                        equipment_name: this.selectedItem.equipment_name,
                        name: sensor.itemData.sensor_name,
                        facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                    })
                }
                return(Object.keys(newVarList).map(unit=>{
                    return  {
                        'layout-overrides': {
                            title:"",
                            colorway: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf'],
                            xaxis: {
                                title: this.$options.filters.translate("Time")
                            },
                            yaxis: {
                                title: unit
                            },
                            zaxis: {
                                title: null
                            },
                            showlegend:true,
                            height:300,
                            hovermode:"x",
                            margin:{
                                l: 50,
                                r: 50,
                                t: 50,
                                pad: 1
                            },
                            legend: {
                                orientation: 'h',
                                y: -0.3
                            },
                        },
                        "x-axis":"timestamp",
                        "y-axis":null,
                        "color-axis":null,
                        "color-axis-scale":null,
                        "color-axis-title":null,
                        'data-payload': newVarList[unit].map(function (selectedVar) {
                            let premap={
                                'filters': {
                                    equipment_name: selectedVar.equipment_name,
                                    sensor_name: selectedVar.name,
                                    facility_name: selectedVar.facility_name,
                                },
                                seriesOverrides:{
                                    type:'scatter',
                                    opacity:1,
                                    xbins: {
                                        size: 1
                                    }
                                },
                                pipeline:[]
                            }

                            return (premap)
                        }),
                    }
                }))
            } else {
                return null
            }
        }
    },
    methods: {
        exportPoints() {
            let cleanedItems = JSON.parse(JSON.stringify(this.allPoints))
            exportCSV(cleanedItems.map(item => this.formatItem(item)))
        },
        formatItem(item) {
            let equipment = this.allEquipments.filter(x => x.equipment_id === item.equipment_id)[0]
            return {
                sensor_id: item.sensor_id ? item.sensor_id : "",
                upstream_id: item.haystack_id ? item.haystack_id : "",
                site: item.facility_name ? item.facility_name : "",
                equip: item.equipment_name ? item.equipment_name : "",
                equip_type: equipment&&equipment.equipment_type ? equipment.equipment_type : "",
                equip_tags: equipment&&equipment.equipment_tags ? JSON.stringify(equipment.equipment_tags) : "[]",
                meta: item.meta ? JSON.stringify(item.meta) : "{}",
                upstream_sensor_name: item.sensor_name_abbr ? item.sensor_name_abbr : item.sensor_name,
                sensor_name: item.sensor_name ? item.sensor_name : "",
                unit: item.unit ? item.unit : "",
                floor: equipment&&equipment.floor ? equipment.floor : "",
                equip_meta: equipment&&equipment.meta ? JSON.stringify(equipment.meta) : "{}",
                sensor_desc: item.sensor_desc ? item.sensor_desc : "",
                connector_id: item.connector_id ? item.connector_id : "",
                calculations_statement: item.calculations_statement ? item.calculations_statement : "",
            }
        },
        formatItemForReverse(item) {
            let equipment = this.allEquipments.filter(x => x.equipment_name === item.equipment_name)[0]
            let existingPoint=this.allPoints.filter(x=>x.equipment_name===item.equipment_name&&(x.connector_id||x.connector_id===0)&&x.haystack_id)[0]
            return {
                sensor_id: item.sensor_id ? item.sensor_id : "",
                upstream_id: item.haystack_id ? item.haystack_id : "",
                site: this.$store.state.pointsListStore.pointsList.facility_name,
                equip: item.equipment_name ? item.equipment_name : "",
                equip_type: equipment&&equipment.equipment_type ? equipment.equipment_type : "",
                equip_tags: equipment&&equipment.equipment_tags ? JSON.stringify(equipment.equipment_tags) : "[]",
                meta: item.meta ? JSON.stringify(item.meta) : "{}",
                upstream_sensor_name: "",
                sensor_name: item.sensor_name ? item.sensor_name : "",
                unit: item.unit ? item.unit : "",
                floor: equipment&&equipment.floor ? equipment.floor : "",
                equip_meta: equipment&&equipment.meta ? JSON.stringify(equipment.meta) : "{}",
                sensor_desc: item.sensor_desc ? item.sensor_desc : "",
                connector_id: existingPoint ? existingPoint.connector_id : "",
                calculations_statement: item.calculations_statement ? item.calculations_statement : "",
                severity: item.severity ? item.severity : "",
                status: item.status ? item.status : "",
                notes: item.notes ? item.notes : "",
            }
        },
        exportAsPointListToMap(){
            let issues=JSON.parse(JSON.stringify(this.refinedMisIssues)).filter(x=>!x.canCalc&&!x.canBeWritable)
            exportCSV(issues.map(item => this.formatItemForReverse(item)))
        },
        formatElderDate(date){
            return moment(date).format('YYYY-MM-DD HH:mm:ss')
        },
        customSearch(item, text) {
            return (item.name && item.name.toLowerCase().indexOf(text.toLowerCase()) > -1) || (item.itemData && item.itemData.sensor_desc && item.itemData.sensor_desc.toLowerCase && item.itemData.sensor_desc.toLowerCase().indexOf(text.toLowerCase()) > -1 || (item.itemData && item.itemData.haystack_id && item.itemData.haystack_id.toLowerCase().indexOf(text.toLowerCase()) > -1))
        },
        getColor(x) {
            return _.get(this.errorColors, x.toLowerCase(), 'green')
        },
        async autoBuildRelationships(){
            let autoRefConfig = this.mappingRefConfig ? this.mappingRefConfig : autoRef
            let incr=0
            for (let item of autoRefConfig){
                let equip1s=this.allEquipments.filter(x=>x.equipment_type===item.equip1_type)
                for (let equip1 of equip1s){
                    let equip2s=this.allEquipments.filter(x=>x.equipment_type===item.equip2_type&&x.floor===equip1.floor)
                    for (let equip2 of equip2s){
                        if (this.allRelationships.filter(x=>x.type===item.type&&x.equip1===equip1.equipment_id&&x.equip2===equip2.equipment_id).length===0){
                            await putEquipmentRelationship(
                                {
                                    type:item.type,
                                    equip1:equip1.equipment_id,
                                    equip2:equip2.equipment_id,
                                    facility_name:this.facilityName
                                })
                            incr++
                        }
                    }
                }
            }
            this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Done. Equipment relationships created: ')+incr})
            this.autoRefDiag=false
        },
        getItemDebugStatus(item){
            let integrityConfig = this.mappingIntegrityConfig ? this.mappingIntegrityConfig : integrity
            let currentTags = item.itemData.equipment_tags&&item.itemData.equipment_tags.length>0 ? item.itemData.equipment_tags : []
            let issuesForType = integrityConfig.filter(x => x.equipmentGroup&&x.equipmentGroup.split(",").includes(item.itemData.equipment_type)&&(!x.equipmentTags||x.equipmentTags.length===0||x.equipmentTags.every(tag=>currentTags.includes(tag))))
            let equipPoints=this.allPoints.filter(x=>x.equipment_name===item.itemData.equipment_name).map(x=>x.sensor_name)
            let ignoredForThisOne=[]
            if (this.knownExistingIssues&&this.knownExistingIssues.length>0){
                ignoredForThisOne=this.knownExistingIssues.filter(x=>x.status==="done").filter(x=>x.equipment_name===item.itemData.equipment_name).map(x=>x.sensor_name)
            }
            if(issuesForType.filter(x => x.importance === "critical").map(x => x.carnotname).filter(x => !equipPoints.includes(x)&&!ignoredForThisOne.includes(x)).length>0){
                return '<span class="ml-2 error--text"><strong>&#x26A0;</strong></span>'
            } else if(issuesForType.filter(x => x.importance === "important").map(x => x.carnotname).filter(x => !equipPoints.includes(x)&&!ignoredForThisOne.includes(x)).length>0){
                return '<span class="ml-2 warning--text"><strong>&#x26A0;</strong></span>'
            }
            return null
        },
        async addPointToCurrent(pointName,pointFormula){
            if (this.selectedItem&&this.selectedType==='equipment'){
                await this.autoCreatePoints([this.selectedItem],pointName,pointFormula)
                this.reloadTree()
            }
        },
        markAllAsDone(item){
            if (confirm(this.$options.filters.translate('Are you sure you want mark '+item.sensor_name+' pending issues as done on all '+item.equipment_type+ '?')) ){
                for (let issue of this.misIssues){
                    if (issue.sensor_name===item.sensor_name&&issue.equipment_type===item.equipment_type&&issue.status==="pending"){
                        issue.status="done"
                        if (item.notes&&item.notes!==""&&(!issue.notes||issue.notes==="")){
                            issue.notes=item.notes
                        }
                    }
                }
            }
        },
        async runMisRename(){
            this.misRenameSelectedPoint.sensor_name=this.misRenameItem.sensor_name
            this.misRenameSelectedPoint.equipment_name=this.misRenameItem.equipment_name
            this.misRenameSelectedPoint.facility_name=this.$store.state.pointsListStore.pointsList.facility_name
            await putPoint(this.misRenameSelectedPoint)
            this.misRenameItem.status="auto-created"
            this.misRenameDialog=false
        },
        misRenameExisting(item){
            this.misRenameSearch=null
            this.misRenameSearch2=null
            this.misRenameSearchBeyondEquipment=false
            this.misRenameSelectedPoint=null
            this.misRenameItem=item
            this.misRenameDialog=true
        },
        async addToMisItem(item){
            await this.autoCreatePoints([item],item.sensor_name,item.formula,false)
            item.status="auto-created"
        },
        async addWritableToMisItem(item){
            await this.autoCreateWritablePoints([item],item.sensor_name,this.writableConnector.connector_id,false)
            item.status="auto-created"
        },
        async closeMisDialog(){
            await putResult({
                'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                'content': this.misIssues.filter(x=>x.status==="done"||(x.notes&&x.notes!=="")),
                'result_name': 'MappingIntegrityIssues',
                'description': ''
            })
            this.misWorkflowDialog=false
            await this.reloadTree()
        },
        async addToAllMisItems(){
            let incr=0
            for (let item of this.misIssues){
                if (item.canCalc&&item.status==="pending"&&this.misWorkflowSeverity.includes(item.severity)){
                    await this.autoCreatePoints([item],item.sensor_name,item.formula,false,true)
                    item.status="auto-created"
                    incr++
                }
            }
            this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Done. Points created: ')+incr})
        },
        async addWritableToAllMisItems(){
            let incr=0
            for (let item of this.misIssues){
                if (item.canBeWritable&&item.status==="pending"&&this.misWorkflowSeverity.includes(item.severity)){
                    await this.autoCreateWritablePoints([item],item.sensor_name,this.writableConnector.connector_id,false,true)
                    item.status="auto-created"
                    incr++
                }
            }
            this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Done. Points created: ')+incr})
        },
        async autoCreatePoints(equips,pointName,pointFormula,doAlert=false,quiet=false,editExisting=false,unit=null){
            let incr=0
            let incrEdit=0
            let exceptioAlreadyExists=[]
            let exceptionMissing=[]
            for (let equip of equips) {
                if (editExisting||this.allPoints.filter(x => x.equipment_name === equip.equipment_name && x.sensor_name === pointName).length === 0) {
                    let formula=pointFormula
                    let canWrite=true
                    if (formula&&formula!=="") {
                        let tbr = formula.match(/df\[(.*?)\]/g)
                        if (tbr) {
                            for (let item of tbr) {
                                if (item.startsWith('df[[')) {
                                    let itemCenters = item.split('[[')[1].split(']')[0].split(',')
                                    let newCenters = []
                                    for (let itemCenterShell of itemCenters) {
                                        let equipName=equip.equipment_name
                                        let iCName=itemCenterShell.split('"')[1].split(" - ")[0]
                                        let itemCenter = itemCenterShell.split('"')[1].split(" - ")[1]
                                        if (iCName!==""&&iCName!==equipName&&iCName!=="equipment"&&iCName!=="equip"){
                                            equipName=iCName
                                        }
                                        let foundItems = this.allPoints.filter(x => x.equipment_name === equipName && x.sensor_name === itemCenter)
                                        if (foundItems.length < 1) {
                                            console.log("No sensor found for " + equipName + " - " + itemCenter);
                                            canWrite = false
                                        } else {
                                            newCenters.push(foundItems[0].sensor_id)
                                        }
                                    }
                                    if (itemCenters.length === newCenters.length) {
                                        formula = formula.replace(item, 'df[[' + newCenters.join(',') + ']')
                                    }
                                } else {
                                    let itemCenterShell = item.split('[')[1].split(']')[0]
                                    let itemCenter = itemCenterShell.split('"')[1].split(" - ")[1]
                                    if (itemCenter) {
                                        let equipName=equip.equipment_name
                                        let iCName=itemCenterShell.split('"')[1].split(" - ")[0]
                                        if (iCName!==""&&iCName!==equipName&&iCName!=="equipment"&&iCName!=="equip"){
                                            equipName=iCName
                                        }
                                        let foundItems = this.allPoints.filter(x => x.equipment_name === equipName && x.sensor_name === itemCenter)
                                        if (foundItems.length < 1) {
                                            console.log("No sensor found for " + equipName + " - " + itemCenter);
                                            canWrite = false
                                        } else {
                                            formula = formula.replace(item, 'df[' + foundItems[0].sensor_id + ']')
                                        }
                                    }
                                }

                            }
                        }
                    }
                    if (canWrite){
                        let newPoint = {
                            sensor_id: null,
                            connector_id: null,
                            sensor_name: pointName,
                            sensor_name_abbr: '',
                            sensor_desc: '',
                            unit:  '',
                            haystack_id: null,
                            faulty:false,
                            weight:1,
                            equipment_name: equip.equipment_name,
                            meta: '',
                            facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                            calculations_statement: formula,
                        }
                        if (unit){
                            newPoint.unit=unit
                        }
                        if (editExisting&&this.allPoints.filter(x => x.equipment_name === equip.equipment_name && x.sensor_name === pointName).length>0){
                            newPoint=JSON.parse(JSON.stringify(this.allPoints.filter(x => x.equipment_name === equip.equipment_name && x.sensor_name === pointName)[0]))
                            if (!newPoint.connector_id&&!newPoint.haystack_id&&newPoint.calculations_statement===formula){
                                continue
                            }
                            newPoint.calculations_statement=formula
                            newPoint.haystack_id=null
                            newPoint.connector_id=null
                            if (unit){
                              newPoint.unit=unit
                            }
                            if (newPoint.meta&&newPoint.meta.tags&&newPoint.meta.tags.includes("writable")){
                                newPoint.meta.tags=newPoint.meta.tags.filter(x=>x!=="writable")
                            }
                            incrEdit++
                        } else {
                            incr++
                        }
                        await putPoint(newPoint)
                    } else {
                        exceptionMissing.push(equip.equipment_name)
                    }
                } else {
                    exceptioAlreadyExists.push(equip.equipment_name)
                }
            }
            if (doAlert){
                let message = this.$options.filters.translate('Done. Points created: ')+incr
                if (incrEdit>0){
                    message+="\n"+this.$options.filters.translate('Points edited: ')+incrEdit
                }
                if (exceptioAlreadyExists.length>0){
                    message+="\n"+this.$options.filters.translate('Points already exists for: ')+exceptioAlreadyExists.join(', ')
                }
                if (exceptionMissing.length>0){
                    message+="\n"+this.$options.filters.translate('Points could not be created for: ')+exceptionMissing.join(', ')
                }
                alert(message)
            } else if (!quiet){
                this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Done. Points created: ')+incr})
            }
        },
        async autoCreateWritablePoints(equips, pointName, connectorId, doAlert = false, quiet = false, editExisting = false) {
            let incr = 0
            let incrEdit = 0
            let exceptioAlreadyExists = []
            for (let equip of equips) {
                if (editExisting || this.allPoints.filter(x => x.equipment_name === equip.equipment_name && x.sensor_name === pointName).length === 0) {
                    let newPoint = {
                        sensor_id: null,
                        connector_id: connectorId,
                        sensor_name: pointName,
                        sensor_name_abbr: '',
                        sensor_desc: '',
                        unit: '',
                        haystack_id: null,
                        faulty: false,
                        weight: 1,
                        equipment_name: equip.equipment_name,
                        meta: {tags: ["writable"]},
                        facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                        calculations_statement: null,
                    }
                    if (equip.canBeWritable&&typeof(equip.writableDefaultValue)!=="undefined"){
                        newPoint.meta.writable_default_value=equip.writableDefaultValue
                    }
                    if (editExisting && this.allPoints.filter(x => x.equipment_name === equip.equipment_name && x.sensor_name === pointName).length > 0) {
                        newPoint = JSON.parse(JSON.stringify(this.allPoints.filter(x => x.equipment_name === equip.equipment_name && x.sensor_name === pointName)[0]))
                        if (newPoint.connector_id === connectorId&&newPoint.meta&&newPoint.meta.tags&&newPoint.meta.tags.includes("writable")) {
                            continue
                        }
                        newPoint.connector_id = connectorId
                        newPoint.calculations_statement = null
                        if (!newPoint.meta||newPoint.meta===""){
                            newPoint.meta = {tags: ["writable"]}
                        } else if (!newPoint.meta.tags) {
                            newPoint.meta.tags = ["writable"]
                        } else if (!newPoint.meta.tags.includes("writable")) {
                            newPoint.meta.tags.push("writable")
                        }
                        if (equip.canBeWritable&&typeof(equip.writableDefaultValue)!=="undefined"){
                            newPoint.meta.writable_default_value=equip.writableDefaultValue
                        }
                        incrEdit++
                    } else {
                        incr++
                    }
                    let createdPoint = await putPoint(newPoint)
                    if (equip.canBeWritable&&typeof(equip.writableDefaultValue)!=="undefined"){
                        await putOptimizationControl({
                            'sensor_id': createdPoint.record.sensor_id,
                            'value': equip.writableDefaultValue,
                            'priority': 8,
                        })
                    }
                } else {
                    exceptioAlreadyExists.push(equip.equipment_name)
                }
            }
            if (doAlert) {
                let message = this.$options.filters.translate('Done. Points created: ') + incr
                if (incrEdit > 0) {
                    message += "\n" + this.$options.filters.translate('Points edited: ') + incrEdit
                }
                if (exceptioAlreadyExists.length > 0) {
                    message += "\n" + this.$options.filters.translate('Points already exists for: ') + exceptioAlreadyExists.join(', ')
                }
                alert(message)
            } else if (!quiet) {
                this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Done. Points created: ') + incr})
            }
        },
        async runMCP() {
            if (this.mcpName && this.mcpName !== "") {
                let equips = JSON.parse(JSON.stringify(this.allEquipments))
                if (this.mcpTypeFilter) {
                    equips = equips.filter(x => x.equipment_type === this.mcpTypeFilter)
                }
                if (this.mcpFloorFilter) {
                    equips = equips.filter(x => x.floor === this.mcpFloorFilter)
                }
                this.loading=true
                this.mcpDialog=false
                await this.autoCreatePoints(equips,this.mcpName,this.mcpForumla,true,false,this.mcpEditExisting,this.mcpUnit)
                this.reloadTree()
            }
        },
        async runMWP() {
            if (this.mwpName && this.mwpName !== ""&&this.writableConnector&&this.writableConnector.connector_id) {
                let equips = JSON.parse(JSON.stringify(this.allEquipments))
                if (this.mwpTypeFilter) {
                    equips = equips.filter(x => x.equipment_type === this.mwpTypeFilter)
                }
                if (this.mwpFloorFilter) {
                    equips = equips.filter(x => x.floor === this.mwpFloorFilter)
                }
                this.loading=true
                this.mwpDialog=false
                await this.autoCreateWritablePoints(equips,this.mwpName,this.writableConnector.connector_id,true,false,this.mwpEditExisting)
                this.reloadTree()
            }
        },
        async runMIS(){
            let existingIssues=[]
            let existingResult=await getResult({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                result_name: 'MappingIntegrityIssues'
            })
            if(existingResult&&existingResult.result.length>0){
                existingIssues=existingResult.result[0].content
            }
            let equips = JSON.parse(JSON.stringify(this.allEquipments))
            equips=equips.filter(x=>x.floor&&!x.floor.toLowerCase().startsWith("backup")&&!x.floor.toLowerCase().startsWith(".backup"))
            let foundIssues=[]
            let integrityConfig = this.mappingIntegrityConfig ? this.mappingIntegrityConfig : integrity
            let availableCalcDef=this.mappingCalculatedConfig ? this.mappingCalculatedConfig : calculatedDef
            let totalPriorityPoints=0
            let totalPriorityIssues=0
            for (let equip of equips){
                let currentTags = equip.equipment_tags&&equip.equipment_tags.length>0 ? equip.equipment_tags : []
                let issuesForType = integrityConfig.filter(x => x.equipmentGroup&&x.equipmentGroup.split(",").includes(equip.equipment_type)&&(!x.equipmentTags||x.equipmentTags.length===0||x.equipmentTags.every(tag=>currentTags.includes(tag))))
                let equipPoints=this.allPoints.filter(x=>x.equipment_name===equip.equipment_name).map(x=>x.sensor_name)
                let integrityIssue = {
                    critical: issuesForType.filter(x => x.importance === "critical").map(x => x.carnotname).filter(x => !equipPoints.includes(x)),
                    important: issuesForType.filter(x => x.importance === "important").map(x => x.carnotname).filter(x => !equipPoints.includes(x)),
                    optional: issuesForType.filter(x => x.importance === "optional").map(x => x.carnotname).filter(x => !equipPoints.includes(x)),
                }
                totalPriorityPoints=totalPriorityPoints+issuesForType.filter(x => x.importance === "critical"|| x.importance === "important").length
                let availableCalcPoints=availableCalcDef.filter(x=>x.equipment_type===equip.equipment_type)
                for (let severity in integrityIssue) {
                    for (let missingSensor of integrityIssue[severity]) {
                        let issue={
                            severity: severity,
                            equipment_name: equip.equipment_name,
                            equipment_type: equip.equipment_type,
                            floor: equip.floor,
                            sensor_name: missingSensor,
                            canCalc:false,
                            canBeWritable:false,
                            formula:null,
                            status:"pending",
                            notes:null
                        }
                        let foundCalcDef=availableCalcPoints.filter(x=>x.name===missingSensor)
                        if (foundCalcDef.length>0&&foundCalcDef[0].requirements.filter(x => !x.includes(" - ")).every(x => equipPoints.includes(x)) && foundCalcDef[0].requirements.filter(x => x.includes(" - ")).every(x => this.allPoints.filter(point => point.equipment_name===x.split(" - ")[0]&&point.sensor_name===x.split(" - ")[1]).length>0)){
                            issue.formula=foundCalcDef[0].formula
                            issue.canCalc=true
                        }
                        let correspondingDef=issuesForType.filter(x => x.carnotname === missingSensor)[0]
                        if (correspondingDef){
                            issue.upperLimit=correspondingDef.upperLimit
                            issue.lowerLimit=correspondingDef.lowerLimit
                            if (correspondingDef.writable){
                                issue.canBeWritable=true
                                if (typeof(correspondingDef.writableDefaultValue)!=="undefined"){
                                    issue.writableDefaultValue=correspondingDef.writableDefaultValue
                                }
                            }

                        }
                        let existingIssue=existingIssues.filter(x=>x.equipment_name===equip.equipment_name&&x.sensor_name===missingSensor)
                        if (existingIssue.length>0){
                            issue.notes=existingIssue[0].notes
                            if (existingIssue[0].status==="done"){
                                issue.status="done"
                            }
                        }
                        if ((severity==="critical"||severity==="important")&&issue.status==="pending"){
                            totalPriorityIssues=totalPriorityIssues+1
                        }
                        foundIssues.push(issue)
                    }
                }
            }
            this.misIssues=foundIssues
            this.completionPercentage=Math.round(((totalPriorityPoints-totalPriorityIssues)/totalPriorityPoints)*100)
            this.misWorkflowDialog=true
        },
        async runMultiRecalc() {
            if (this.recalcName&&this.recalcName!==""){
                this.loading=true
                this.recalcDiag=false
                let matchingSensors=this.allPoints.filter(x=>x.sensor_name===this.recalcName&&x.calculations_statement&&x.calculations_statement!==""&&x.equipment_name&&x.equipment_name!=="")
                if (matchingSensors.length>0){
                    let incr=0
                    for (let sensor of matchingSensors) {
                        await putJob({
                            'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                            'job_type': 'Recalculate Calculated Points',
                            'job_status': 'pending',
                            'meta': {
                                'equipment_name - sensor_name': sensor.equipment_name+" - "+sensor.sensor_name,
                            }
                        })
                        incr++
                    }
                    this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Done. Recalculation jobs created: ')+incr})
                } else {
                    this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('No calculated points found for this name')})
                }
                this.loading=false
            }
        },
        getConnectorInfo(id){
            let found=this.connectors.filter(x=>x.connector_id===id)
            if (found&&found[0]){
                return found[0].type+ " - "+found[0].name
            }
            return id
        },
        addFromConnector(item){
            this.itemFromConnector=item
            this.dialog3=true
        },
        async deleteSensor (sensor) {
            if (confirm(this.$options.filters.translate('Are you sure you want to delete this sensor?')) ){
                await deletePoint({
                    'sensor_id': sensor.sensor_id
                })
                this.clearSelection()
                this.reloadTree()
            }
        },
        async runPointRecalc () {
            if (confirm(this.$options.filters.translate('Are you sure you want to recalculate data for this calculated point?')) ){
                await putJob({
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'job_type': 'Recalculate Calculated Points',
                    'job_status': 'pending',
                    'meta': {
                        'equipment_name - sensor_name': this.selectedItem.equipment_name+" - "+this.selectedItem.sensor_name,
                    }
                })
                await this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Recalculation job requested')})
            }
        },
        async runPointRedump () {
                await putJob({
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'job_type': 'import connector his',
                    'job_status': 'pending',
                    'meta': {
                        'sensor_id': this.selectedItem.sensor_id,
                        'end_date':this.importJobEndDate,
                        'start_date':this.importJobStartDate,
                    }
                })
                await this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('History re-import job requested')})
        },
        async deleteEquipment (equipment) {
            if (confirm(this.$options.filters.translate('Are you sure you want to delete this equipment?. The deletion process is asynchronous. You can use the dashboard as usual while it runs in the background.')) ){
                await putEquipment(
                    {
                        'equipment_id': equipment.equipment_id,
                        'equipment_name': equipment.equipment_name,
                        'floor': equipment.floor,
                        'equipment_type': "trash",
                        'equipment_tags': equipment.equipment_tags,
                        'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                        'notes': equipment.notes,
                        'meta': equipment.meta,
                        'graphic_id': equipment.graphic_id,
                    }
                )
                await putJob({
                    'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
                    'job_type': 'remove old readings for type',
                    'job_status': 'pending',
                    'meta': {
                        'date': moment().format('YYYY-MM-DD'),
                        'type':"trash",
                        'delete_equipment':true,
                    }
                })
                this.clearSelection()
                this.reloadTree()
            }
        },
        handleClick(item){
            if(!item.itemType||!item.itemData){
                this.clearSelection()
            } else {
                this.selectItem(item.itemType,item.itemData,item.id,item.children)
            }
        },
        selectItem(type,item,id,children){
            this.dialog=false
            this.dialog2=false
            this.selectedType=type
            this.selectedItem=item
            this.selectedItemChildren=children
            this.selectedID=id
        },
        clearSelection(){
            this.dialog=false
            this.dialog2=false
            this.selectedType=null
            this.selectedItem=null
            this.selectedItemChildren=null
            this.selectedID=null
        },
        syncSearches() {
            this.search2 = this.search
        },
        syncMisSearches() {
            this.misSearch2 = this.misSearch
        },
        syncMisRenameSearches() {
            this.misRenameSearch2 = this.misRenameSearch
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
        arrangeIntoTree(paths,childrenList,equipDetails) {
            let tree = [];
            for (let i = 0; i < paths.length; i++) {
                let path = paths[i];
                let currentLevel = tree;
                for (let j = 0; j < path.length; j++) {
                    let part = path[j];
                    let existingPath = this.findWhere(currentLevel, 'name', part);
                    if (existingPath) {
                        currentLevel = existingPath.children;
                    } else {
                        let newPart = {
                            name: part,
                            id: path.join('-')+'-'+part,
                            children: [],
                        }
                        if(equipDetails[part]){
                            newPart.itemType="equipment"
                            newPart.itemData=equipDetails[part]
                        }
                        if(childrenList[part]){
                            newPart.children=childrenList[part]
                        }
                        currentLevel.push(newPart);
                        currentLevel = newPart.children;
                    }
                }
            }
            return tree;
        },
        findWhere(array, key, value) {
            let t = 0;
            while (t < array.length && array[t][key] !== value) {
                t++;
            }
            if (t < array.length) {
                return array[t]
            } else {
                return false;
            }
        },
        async clearPriority(sensor_id,priority){
            await putOptimizationControl({
                'sensor_id': sensor_id,
                'value': null,
                'priority': priority,
            })
            this.writeValueDialog = false
            this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Update request sent')})
        },
        async updateControl(sensor_id, value, priority,duration) {
            await putOptimizationControl({
                'sensor_id': sensor_id,
                'value': value===""||value==="null" ? null : value,
                'priority': priority&&priority!=="" ? priority : 8,
                'duration':duration,
            })
            this.writeValueDialog = false
            this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Update request sent')})
        },
      async reloadTree() {
          this.loading=true
          this.dialog=false
          this.dialog2=false
          this.dialog3=false
          let facilityName=this.$store.state.pointsListStore.pointsList.facility_name
          let equipsDF = await getEquipment({
              facility_name: facilityName
          })
          let pointsDF = await getPoint({
              facility_name: facilityName
          })
          let relationshipsDf = await getEquipmentRelationship({
              facility_name: facilityName
          })
          let existingIssuesResult=await getResult({
              facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
              result_name: 'MappingIntegrityIssues'
          })
          if(existingIssuesResult&&existingIssuesResult.result.length>0){
              this.knownExistingIssues=existingIssuesResult.result[0].content
          }
          if (this.selectedItem&&this.selectedType){
              if (this.selectedType === "sensor") {
                  this.selectedItem = pointsDF.result.filter(x => x.sensor_id === this.selectedItem.sensor_id)[0]
              } else if (this.selectedType === "equipment") {
                  this.selectedItem = equipsDF.result.filter(x => x.equipment_id === this.selectedItem.equipment_id)[0]
              }
          }
          this.allEquipments=JSON.parse(JSON.stringify(equipsDF.result))
          this.allPoints=JSON.parse(JSON.stringify(pointsDF.result))
          this.allRelationships=JSON.parse(JSON.stringify(relationshipsDf.result))
          this.mappedIds = pointsDF['result'].map(x=>{return {haystack_id:x.haystack_id,connector_id:x.connector_id}})
          let childrenList=[]
          let equipDetails=[]
          for(let equipment of equipsDF.result){
              let points=pointsDF.result.filter(x=>x.equipment_id&&x.equipment_id===equipment.equipment_id).map(x=>{return{
                  id:x.sensor_id,
                  name:x.sensor_name,
                  children: [],
                  equipment_name:equipment.equipment_name,
                  facility_name:facilityName,
                  itemType:"sensor",
                  itemData:x,
              }})
              points.sort((a, b) => (a.name > b.name) ? 1 : -1)
              childrenList[equipment.equipment_name]=points
              equipDetails[equipment.equipment_name]=equipment
          }
          equipsDF.result.sort((a, b) => (a.equipment_name > b.equipment_name) ? 1 : -1)
          let equipPaths=[];
          for (let equip of equipsDF.result){
              let newPath=[]
              if(equip.floor&&equip.floor!==""&&equip.floor!=="NaN"){
                  if (equip.floor.startsWith(".")&&this.$store.state.userStore.user.content.role!=="admin"){
                      continue
                  }
                  newPath=equip.floor.split('>').concat([equip.equipment_name])
              } else if (equip.equipment_type&&equip.equipment_type!==""&&equip.equipment_type!==equip.equipment_name){
                  newPath=[equip.equipment_type,equip.equipment_name]
              } else {
                  newPath=[equip.equipment_name]
              }
              if(newPath.length>1){
                  for (let index=0; index<newPath.length; index++){
                      if(index<newPath.length&&newPath[index]===newPath[index+1]){
                          newPath[index]=newPath[index]+" "
                      }
                  }
              }
              equipPaths.push(newPath)
          }
          equipPaths=sortFloors(equipPaths)
          this.tree=this.arrangeIntoTree(equipPaths,childrenList,equipDetails);
          this.loading=false
      }
    }
  }
</script>

<style scoped>
.cursor-as-pointer{
    cursor: pointer !important;
}
.no-field-underline >>> .v-input__slot::before {
    border-style: none !important;
}
</style>
